<template>
    <section>
        <div class="space-footer"></div>

        <footer class="sticky-footer bg-white">
            <div class="container my-auto">
                <div class="copyright text-center my-auto">
                    <span>Arquitetado e produzido por &copy; <a href="http://www.dad.eng.br" target="_blank">DAD Engenharia</a> 2019</span>
                </div>
            </div>
        </footer>
    </section>
</template>

<script>
    export default { name: 'template-footer' }
</script>

<style scoped>
    .space-footer {
        height: 100px;
    }

    footer {
        position: fixed;
        width: 100%;
        bottom: 0;
    }
</style>
